import { h } from 'preact';
import { FlagQms, FlagSpa, Inline, styled } from '@lessonnine/design-system.lib';

const OverlappingContainer = styled.div`
  margin: 0 -8px;
  ${({ showOnTop }) => (showOnTop ? `z-index: 1;` : '')}
  :first-of-type {
    margin-left: 0;
  }
  :last-of-type {
    margin-right: 0;
  }
`;

function CombinedSpanishesFlag() {
  return (
    <Inline>
      <OverlappingContainer>
        <FlagSpa />
      </OverlappingContainer>
      <OverlappingContainer showOnTop>
        <FlagQms />
      </OverlappingContainer>
    </Inline>
  );
}

export { CombinedSpanishesFlag };
